export default {
  init() {
    const blocks = Array.from(document.querySelectorAll(".subscription"));
    if (!blocks.length) return;

    for (const block of blocks) {
      const select = block.querySelector(".subscription__select-input");
      const priceEl = block.querySelector(".subscription__price");
      const button = block.querySelector(".book-full__buy-button");

      if (!select || !priceEl || !button) continue;

      const applySelection = () => {
        const option = select.selectedOptions[0];
        if (!option) return;

        const id = option.value;
        const price = option.dataset.price;

        if (id) {
          button.dataset.bookId = id;
        }
        if (price) {
          priceEl.textContent = price;
        }
      };

      select.addEventListener("change", applySelection);
      applySelection();
    }
  },
};

